import { createContext, type ReactNode, useContext } from 'react';
import type { Db } from '../cliente';

const ContextoDb = createContext<Db | null>(null);

/** Entrega o cliente Supabase do app aos hooks. Um por app, criado na inicialização. */
export function ProvedorApi({ db, children }: { db: Db; children: ReactNode }) {
  return <ContextoDb.Provider value={db}>{children}</ContextoDb.Provider>;
}

export function useDb(): Db {
  const db = useContext(ContextoDb);
  if (!db) throw new Error('useDb precisa estar dentro de <ProvedorApi>.');
  return db;
}
